import { render, staticRenderFns } from "./CFormType.vue?vue&type=template&id=1449d269"
import script from "./CFormType.vue?vue&type=script&lang=js"
export * from "./CFormType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1449d269')) {
      api.createRecord('1449d269', component.options)
    } else {
      api.reload('1449d269', component.options)
    }
    module.hot.accept("./CFormType.vue?vue&type=template&id=1449d269", function () {
      api.rerender('1449d269', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/CFormType.vue"
export default component.exports